import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { LocationStrategy } from '@angular/common';
import { WatcherService } from '../services/watcher.service';

export const IsHostGuard: CanActivateFn = (route, state) => {
    const store = inject(Store)
    const router = inject(Router)
    const _location = inject(LocationStrategy)
    const _watcherService = inject(WatcherService);
    let _lang = 'en';
    _watcherService.getLang().subscribe(lang => {
        _lang = lang;
    })
    return store.select('auth').pipe(
        map(authRes => {
            const user = authRes.user;
            switch (user?.type) {
                case undefined:
                    router.navigate(['/'])
                    return false;
                case null:
                    router.navigate(['/'])
                    return false;
                case 1:
                    router.navigate(['/'])
                    return false;
                case 2:
                    if (_location.path() == _lang + '/service-agreement') {
                        if (user?.serviceAgreement == 1) {
                            router.navigate(['/']);
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                case 4:
                    router.navigate(['/']);
                    return false;
                default:
                    router.navigate(['/'])
                    return true;
            }
        })
    )
}
